import { useState, useEffect } from "react";

const Pagination = ({
  page,
  totalPages,
  rowsPerPage,
  onPageChange,
  onPageSizeChange,
  className = "flex-nowrap items-center"
}) => {
  const PAGINATION_ROWS_LIMITS = [5, 10, 25, 50];
  const [inputPage, setInputPage] = useState(page);
  const handlePageInput = (e) => {
    setInputPage(e.target.value);
  };

  const handlePageSubmit = (e) => {
    e.preventDefault();
    let newPage = Number(inputPage);
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    } else {
      setInputPage(page); // reset if invalid
    }
  };

  useEffect(() => {
    setInputPage(page);
  }, [page]);

  return (
    <div className="flex items-center justify-end gap-2 mt-2 px-2 sm:px-4">
      <div className={`flex  ${className} gap-4 md:text-xs text-sm`}>
        {/* Left side: pagination controls */}
        <div className="flex items-center gap-2 md:text-xs text-sm whitespace-nowrap">
          <button
            className="px-2 sm:px-3 py-1 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
          >
            Prev
          </button>

          <form
            onSubmit={handlePageSubmit}
            className="flex items-center gap-1 flex-nowrap"
          >
            <input
              type="number"
              min="1"
              max={totalPages}
              value={inputPage}
              onChange={handlePageInput}
              className="w-10 sm:w-12 border py-1 rounded text-center text-xs sm:text-sm"
            />
            <span className="text-xs sm:text-sm">of {totalPages}</span>
          </form>

          <button
            className="px-2 sm:px-3 py-1 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>

        {/* Right side: pagination controls */}
        <div className="flex items-center gap-1 sm:gap-2 justify-end text-xs sm:text-sm whitespace-nowrap">
          <label htmlFor="rows" className="text-xs sm:text-sm">
            Rows per page:
          </label>
          <select
            id="rows"
            value={rowsPerPage}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="border rounded text-sm py-1"
          >
            {PAGINATION_ROWS_LIMITS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
